import { cleanSchema, serializeJsonLd } from "./schema";

type JsonLdProps = {
  data: Record<string, unknown> | null | (Record<string, unknown> | null)[];
};

export function JsonLd({ data }: JsonLdProps) {
  const entries = (Array.isArray(data) ? data : [data]).filter(Boolean);

  return (
    <>
      {entries.map((entry, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: serializeJsonLd(cleanSchema(entry))
          }}
        />
      ))}
    </>
  );
}
